export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-ri-at-line', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-ri-arrow-right-double-line', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-ri-mail-add-line', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-ri-chat-new-line',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: ['i-ri-chat-new-line', 'text-n-blue-11'],
  SLA_MISSED_FIRST_RESPONSE: ['i-ri-heart-line', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-ri-heart-line', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-ri-heart-line', 'text-n-ruby-11'],
  KANBAN_ITEM_ASSIGNMENT: ['i-ri-kanban-view', 'text-n-blue-text'],
  KANBAN_ITEM_UNASSIGNMENT: ['i-ri-kanban-view', 'text-n-blue-text'],
  KANBAN_CHECKLIST_ITEM_ASSIGNMENT: ['i-ri-list-check', 'text-n-blue-text'],
  KANBAN_CHECKLIST_ITEM_UNASSIGNMENT: ['i-ri-list-check', 'text-n-blue-text'],
  CAPTAIN_HANDOFF: ['i-ri-robot-2-line', 'text-n-brand'],
  CAPTAIN_FOLLOW_UP_DUE: ['i-ri-time-line', 'text-n-brand'],
  CAPTAIN_RUNNER_FAILURE: ['i-ri-error-warning-line', 'text-n-brand'],
  CAPTAIN_PAUSED: ['i-ri-pause-circle-line', 'text-n-brand'],
  CAPTAIN_SCHEDULING_FAILED: ['i-ri-calendar-close-line', 'text-n-brand'],
  CAPTAIN_PENDING_AUTO_RESOLVED: ['i-ri-checkbox-circle-line', 'text-n-brand'],
  TASK_ASSIGNED: ['i-ri-task-line', 'text-n-blue-11'],
  TASK_STATUS_CHANGED: ['i-ri-arrow-up-down-line', 'text-n-blue-11'],
  TASK_DEPENDENCY_RESOLVED: ['i-ri-node-tree', 'text-n-blue-11'],
  TASK_MENTION: ['i-ri-at-line', 'text-n-blue-11'],
  VOIP_HOT_LEAD: ['i-ri-fire-line', 'text-n-amber-11'],
  VOIP_SALE_CLOSED: ['i-ri-money-dollar-circle-line', 'text-n-amber-11'],
  VOIP_NEGATIVE_SENTIMENT: ['i-ri-emotion-unhappy-line', 'text-n-amber-11'],
  VOIP_CRITICAL_KEYWORD: ['i-ri-alarm-warning-line', 'text-n-amber-11'],
  VOIP_MISSED_HOT_CALL: ['i-ri-phone-missed-line', 'text-n-amber-11'],
  VOIP_APPOINTMENT_REMINDER: ['i-ri-calendar-check-line', 'text-n-amber-11'],
  VOIP_SLA_VIOLATION: ['i-ri-timer-flash-line', 'text-n-amber-11'],
  LEAD_CAPTURE_FORM: ['i-ri-user-add-line', 'text-n-teal-11'],
};
